export default "__VITE_ASSET__BhTufN7t__"